import { useContext, useEffect, useRef } from 'react';
import { GoogleAnalyticsContext } from '../../GoogleAnalytics';
import { useStepper } from '../../Stepper';
import rowflag from '../assets/row.png';
import StepWrapper from './StepWrapper';

export function PreferentialOrigin() {
  const { stepBackward, localData, setDataByKey, activeStepKey, unvisitStep, gotoStep } = useStepper();

  const handleChange = (e) => {
    setDataByKey('pref', e.target.value);
    if (!localData.euPrefSelected) {
      setDataByKey('euPref', e.target.value);
    }
  };

  const nextPage = () => {
    if (!localData.pref) {
      return;
    }
    unvisitStep('eu_origin');
    gotoStep('Transit_MRN');
  };

  const previousPage = () => {
    unvisitStep('Preferential Origin');
    stepBackward('1. Direction');
  };

  const isInitialized = useRef(false);
  const ga = useContext(GoogleAnalyticsContext);

  useEffect(() => {
    if (ga.gaInitialized) {
      if (activeStepKey === 'Preferential Origin' && isInitialized.current === false) {
        isInitialized.current = true;
        window?.gtag?.('event', '1. PrefOrigin', {
          event_category: 'EPO',
        });
      }
    }
  }, [activeStepKey, ga.gaInitialized]);

  return (
    <StepWrapper
      stepTitle="Preferential Origin"
      stepText="Preferential Origin"
      stepKey="Preferential Origin"
      handleNextClick={nextPage}
      handleBackClick={previousPage}
      hideUntilActive
      hideUnlessVisited
    >
      <div className="d-flex step-banner justify-content-center">
        <div
          className="d-flex justify-content-center"
          style={{ borderRadius: '15px', marginTop: '34px', marginBottom: '34px', backgroundColor: '#184795' }}
        >
          <img
            src={rowflag}
            width="110"
            height="110"
            alt=""
            className=""
            style={{
              borderRadius: '15px',
              marginTop: '10px',
              marginBottom: '10px',
              marginRight: '48px',
              marginLeft: '43px',
            }}
          />
        </div>
      </div>
      <div className="d-flex flex-column  align-self-center mt-auto" style={{ maxWidth: '390px' }}>
        <span className="d-flex align-self-center" style={{ fontWeight: '500' }}>
          Do all your invoice items have preferential origin?
        </span>
        <div className="d-flex align-self-center" style={{ fontWeight: '500' }}>
          <span>
            Click&nbsp;
            <a href="https://www.eori.uk/origin" target="_blank" rel="noreferrer">
              HERE
            </a>{' '}
            for more information.
          </span>
        </div>
      </div>
      <label className="d-inline-flex justify-content-center mt-auto gap-3 ">
        <input type="radio" name="preforigin" value="yes" checked={localData.pref === 'yes'} onChange={handleChange} />
        <span>Yes</span>
      </label>
      <label className="d-inline-flex justify-content-center gap-3 mt-2">
        <input type="radio" name="preforigin" value="no" checked={localData.pref === 'no'} onChange={handleChange} />
        <span>No</span>
      </label>
    </StepWrapper>
  );
}
